import util from '../util'

let controller = 'Dominios'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall']), {
  GetByTipo: function (tipo, codigo) {
    let params = {
      parameters: [
        { name: 'tipo', value: tipo },
        { name: 'codigo', value: codigo }
      ]
    }
    return util.Axios.GetAll(controller, params)
  }
})
